// client/src/components/forms/TextInput.js
//
// Bare single-line text input. Slotted inside a FormField for label +
// helper + error. Controlled component: pass value + onChange(newValue),
// where onChange receives the string directly (not the event). Any other
// native input prop passes through via ...rest.

export function TextInput({
  value,
  onChange,
  className = '',
  type = 'text',
  ...rest
}) {
  return (
    <input
      type={type}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      className={[
        'block w-full',
        'bg-paper text-ink',
        'border border-rule rounded-md',
        'px-3 py-2',
        'text-base',
        'placeholder:text-inkSub',
        'focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      ].join(' ')}
      {...rest}
    />
  );
}